import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase project configuration
const firebaseConfig = {
    apiKey: 'AIzaSyBlamTPoQFaTnxmGkugYyxyLSLzLKxDZMM',
    authDomain: 'mhbinterlock-a2fe4.firebaseapp.com',
    projectId: 'mhbinterlock-a2fe4',
    // storageBucket: 'YOUR_STORAGE_BUCKET',
    messagingSenderId: '899474014520',
    appId: '1:899474014520:web:57e3137422e474a331c1cd',
    vapidKey: "BD7RaQYi0EvYfOW4TgCdNOjRgpqtsGP-FuLhrnUcvRw8VpO8c_dkFtOXml7_gEA2DkmW2MjZdW-WOdpV9K08vyk"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export { getToken, onMessage };
